(function ($) {

    $(document).ready(function () {

        $('.menu-trigger').click(function(){
            $('header').toggleClass('menu-open');
        });


        $('header .icon-search').click(function(){
            $('.search-form').fadeIn('slow');
            $('html').css('overflow','hidden');
        });
        $('.search-form .close').click(function(){
            $('.search-form').fadeOut('slow');
            $('html').removeAttr('style');
        });

        //************************************
        // Fixed header when scroll
        //************************************

        $(window).on('scroll load', function () {
            if ($(window).scrollTop() >= 50) {
                $('header').addClass('fixed');
            }
            else $('header').removeClass('fixed');
        });
    });

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/custom/menu.es6